module.exports = __webpack_public_path__ + "img/support_bg.ee4e26ae.png";